import { Box, Chip } from '@mui/material';
import { useCallback } from 'react';
import { IdType, TableInstance } from 'react-table';

type FilterChipBarProps<T extends object> = {
    instance: TableInstance<T>;
};

export default function FilterChipBar<T extends object>({ instance }: FilterChipBarProps<T>) {
    const {
        allColumns,
        setFilter,
        state: { filters },
    } = instance;
    const handleDelete = useCallback(
        (id: string | number) => {
            setFilter(id as IdType<T>, undefined);
        },
        [setFilter]
    );

    return Object.keys(filters).length > 0 ? (
        <Box marginLeft={2.5} padding='10px 0 15px 10px' width='100%'>
            <Box component='span' paddingRight={1.25}>
                Active filters:
            </Box>
            {filters &&
                allColumns.map(column => {
                    const filter = filters.find(f => f.id === column.id);
                    const value = filter && filter.value;
                    return (
                        value && (
                            <Chip
                                sx={{ marginRight: 1 }}
                                color='secondary'
                                key={column.id}
                                label={
                                    <>
                                        <Box component='span' marginRight={0.5}>
                                            {column.render('Header')}:{' '}
                                        </Box>
                                        {value instanceof Array ? `Since ${value[0]}` : value}
                                    </>
                                }
                                onDelete={() => handleDelete(column.id)}
                                variant='outlined'
                            />
                        )
                    );
                })}
        </Box>
    ) : null;
}
